class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  disableLoading(line) {
    super.disableLoading(line);
    // Re-initialize quantity inputs after DOM replacement
    requestAnimationFrame(() => {
      document.querySelectorAll('cart-drawer-items quantity-input').forEach((qi) => {
        const input = qi.querySelector('input');
        if (!input) return;
        qi.input = input;
        if (typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
      });
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// As alocações de desconto de um carrinho existente só são recalculadas pela
// Shopify quando há mutação no carrinho. Re-enviar os códigos atuais no load
// força a reavaliação (ex.: cupom reconfigurado no admin após o carrinho criado).
async function refreshCartDiscounts() {
  const codes = Array.from(document.querySelectorAll('.cdv2-footer__discount-remove'))
    .map((el) => el.dataset.discountCode)
    .filter(Boolean);
  const hasAnyDiscount = codes.length > 0 || document.querySelector('.cdv2-footer__discount-tag');
  if (!hasAnyDiscount) return;

  try {
    const body = JSON.stringify({
      discount: codes.join(','),
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });
    const response = await fetch(routes.cart_update_url, { ...fetchConfig(), body });
    if (!response.ok) return;
    const state = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !state.sections) return;

    drawer.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !state.sections[section.id]) return;
      sectionElement.innerHTML = drawer.getSectionInnerHTML(state.sections[section.id], section.selector);
    });
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  } catch (err) {
    /* mantém o estado renderizado pelo servidor */
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshCartDiscounts);
} else {
  refreshCartDiscounts();
}

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.cdv2-coupon__toggle');
  if (!toggle) return;

  const form = document.getElementById('CartDrawer-CouponForm');
  if (!form) return;

  form.removeAttribute('hidden');
  toggle.setAttribute('aria-expanded', 'true');
  toggle.setAttribute('hidden', '');
  const closeBtn = document.querySelector('.cdv2-coupon__close');
  if (closeBtn) closeBtn.removeAttribute('hidden');
  const input = form.querySelector('.cdv2-coupon__input');
  if (input) input.focus();
});

document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('.cdv2-coupon__close');
  if (!closeBtn) return;

  const form = document.getElementById('CartDrawer-CouponForm');
  if (!form) return;

  form.setAttribute('hidden', '');
  closeBtn.setAttribute('hidden', '');
  const toggle = document.querySelector('.cdv2-coupon__toggle');
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.removeAttribute('hidden');
  }
  const errorEl = document.querySelector('.cdv2-coupon__error');
  if (errorEl) errorEl.setAttribute('hidden', '');
});

async function applyCartDrawerCoupon() {
  const form = document.getElementById('CartDrawer-CouponForm');
  if (!form) return;

  const input = form.querySelector('.cdv2-coupon__input');
  const applyBtn = form.querySelector('.cdv2-coupon__apply');
  const errorEl = document.querySelector('.cdv2-coupon__error');
  const code = input ? input.value.trim() : '';
  if (!code) return;

  if (errorEl) errorEl.setAttribute('hidden', '');
  if (applyBtn) applyBtn.disabled = true;
  if (input) input.disabled = true;

  const existingCodes = Array.from(document.querySelectorAll('.cdv2-footer__discount-remove'))
    .map((el) => el.dataset.discountCode)
    .filter(Boolean);
  const codes = existingCodes.concat(code).join(',');

  try {
    const body = JSON.stringify({
      discount: codes,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });
    const response = await fetch(routes.cart_update_url, { ...fetchConfig(), body });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const state = await response.json();

    const codeEntry = (state.discount_codes || []).find(
      (d) => (d.code || '').toLowerCase() === code.toLowerCase()
    );
    const applied = !!(codeEntry && codeEntry.applicable);

    if (!applied) {
      if (codeEntry) {
        fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({ discount: existingCodes.join(',') }),
        }).catch(() => {});
      }
      if (errorEl) errorEl.removeAttribute('hidden');
      if (applyBtn) applyBtn.disabled = false;
      if (input) {
        input.disabled = false;
        input.focus();
        input.select();
      }
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.renderContents({ sections: state.sections });
  } catch (err) {
    console.error('Failed to apply discount:', err);
    if (errorEl) errorEl.removeAttribute('hidden');
    if (applyBtn) applyBtn.disabled = false;
    if (input) input.disabled = false;
  }
}

document.addEventListener('click', (e) => {
  if (e.target.closest('.cdv2-coupon__apply')) applyCartDrawerCoupon();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' && e.target.matches && e.target.matches('.cdv2-coupon__input')) {
    e.preventDefault();
    applyCartDrawerCoupon();
  }
});

// Remove discount code from cart drawer
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cdv2-footer__discount-remove');
  if (!btn) return;

  btn.disabled = true;
  const removedCode = btn.dataset.discountCode;
  const remainingCodes = Array.from(document.querySelectorAll('.cdv2-footer__discount-remove'))
    .map((el) => el.dataset.discountCode)
    .filter((code) => code && code !== removedCode)
    .join(',');

  try {
    const body = JSON.stringify({
      discount: remainingCodes,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });
    const response = await fetch(routes.cart_update_url, { ...fetchConfig(), body });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const state = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.renderContents({ sections: state.sections });
  } catch (err) {
    console.error('Failed to remove discount:', err);
    btn.disabled = false;
  }
});
